import { render, staticRenderFns } from "./CreatePostPrimaryPhoto.vue?vue&type=template&id=171431bf&"
import script from "./CreatePostPrimaryPhoto.vue?vue&type=script&lang=js&"
export * from "./CreatePostPrimaryPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports